/* ============================================================
   ILLEGAL SHIRTS — THEME JS
   ============================================================ */

/* ------ HEADER: Transparent → Solid on scroll ------ */
(function() {
  const header = document.getElementById('site-header');
  if (!header) return;
  const headerWrapper = document.getElementById('shopify-section-header-group-header') || header.parentElement;

  const heroSection = document.getElementById('hero-section');
  const threshold = heroSection ? heroSection.offsetHeight * 0.3 : -1;

  function onScroll() {
    const solid = window.scrollY > threshold;
    header.classList.toggle('is-solid', solid);
    if (headerWrapper) headerWrapper.classList.toggle('is-solid', solid);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

/* ------ MENU DRAWER ------ */
const IllegalMenu = {
  searchTimeout: null,
  popularSearches: ['I Am Afraid Of Women', 'Do Not Narcan Me', 'Chicken Tender Slut', 'Custom shirts', 'Matching sets', 'Flags'],

  open() {
    // Reset search state on open
    const input = document.getElementById('menu-search-input');
    if (input) input.value = '';
    this.toggleSearchMode(false);

    document.getElementById('menu-backdrop')?.classList.add('open');
    document.getElementById('menu-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    document.getElementById('menu-backdrop')?.classList.remove('open');
    document.getElementById('menu-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  switchTab(index) {
    document.querySelectorAll('.menu-tab').forEach(t => t.classList.toggle('active', t.dataset.tab == index));
    document.querySelectorAll('.menu-tab-panel').forEach(p => p.classList.toggle('active', p.dataset.tabPanel == index));
  },

  getRecentSearches() {
    try { return JSON.parse(localStorage.getItem('illegal_recent_searches') || '[]'); }
    catch { return []; }
  },

  addRecentSearch(term) {
    const searches = this.getRecentSearches().filter(s => s.toLowerCase() !== term.toLowerCase());
    searches.unshift(term);
    localStorage.setItem('illegal_recent_searches', JSON.stringify(searches.slice(0, 5)));
  },

  toggleSearchMode(hasText) {
    const defaultContent = document.getElementById('menu-default-content');
    const searchContent = document.getElementById('menu-search-content');
    const clearBtn = document.getElementById('menu-search-clear');

    if (hasText) {
      if (defaultContent) defaultContent.style.display = 'none';
      if (searchContent) searchContent.style.display = 'block';
      clearBtn?.classList.add('visible');
      this.renderSuggestions();
    } else {
      if (defaultContent) defaultContent.style.display = '';
      if (searchContent) searchContent.style.display = 'none';
      clearBtn?.classList.remove('visible');
    }
  },

  renderSuggestions() {
    const container = document.getElementById('menu-search-suggestions');
    if (!container) return;

    const recent = this.getRecentSearches();
    const clockSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>';
    const trendSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/></svg>';

    let html = '<div id="menu-predictive-results"></div>';

    if (recent.length > 0) {
      html += '<div class="menu-search-section-label">RECENT</div>';
      recent.forEach(term => {
        html += `<button type="button" class="menu-search-item recent" data-search-term="${term}">${clockSvg}<span>${term}</span></button>`;
      });
    }

    html += '<div class="menu-search-section-label" style="margin-top: 0.5rem;">POPULAR</div>';
    this.popularSearches.forEach(term => {
      html += `<button type="button" class="menu-search-item popular" data-search-term="${term}">${trendSvg}<span>${term}</span></button>`;
    });



    container.innerHTML = html;
  },

  async fetchPredictive(query) {
    if (query.length < 2) {
      const el = document.getElementById('menu-predictive-results');
      if (el) el.innerHTML = '';
      return;
    }

    try {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      if (!res.ok) return;
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      const resultsEl = document.getElementById('menu-predictive-results');
      if (!resultsEl) return;

      if (products.length === 0) {
        resultsEl.innerHTML = '';
        return;
      }

      let html = '<div class="menu-search-section-label" style="margin-top: 0.5rem;">RESULTS</div>';
      products.forEach(p => {
                let imgSrc = p.featured_image || p.image || '';
        if (imgSrc && typeof imgSrc === 'object') imgSrc = imgSrc.url || imgSrc.src || '';
        const imgUrl = imgSrc && imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;
        const img = imgUrl ? `<img src="${imgUrl}" alt="${p.title}" loading="lazy">` : '';
        const price = typeof p.price === 'number' ? (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : '$' + p.price;
        html += `<a href="${p.url}" class="menu-search-result" onclick="IllegalMenu.close()">
          ${img}
          <div>
            <div class="menu-search-result-title">${p.title}</div>
            <div class="menu-search-result-price">${price}</div>
          </div>
        </a>`;
      });
      html += `<a href="/search?q=${encodeURIComponent(query)}&type=product" class="menu-search-view-all" onclick="IllegalMenu.close()">VIEW ALL RESULTS</a>`;

      resultsEl.innerHTML = html;
    } catch (err) {
      console.error('Predictive search error:', err);
    }
  },

  handleSearchInput(value) {
    const hasText = value.trim().length > 0;
    this.toggleSearchMode(hasText);

    clearTimeout(this.searchTimeout);
    if (hasText) {
      this.searchTimeout = setTimeout(() => this.fetchPredictive(value.trim()), 120);
    }
  },

  clearSearch() {
    const input = document.getElementById('menu-search-input');
    if (input) { input.value = ''; input.focus(); }
    this.toggleSearchMode(false);
  }
};

// Menu event listeners — run immediately since script is at end of body
(function initMenu() {
  function setup() {
    // Tab switching
    document.querySelectorAll('.menu-tab').forEach(tab => {
      tab.addEventListener('click', () => IllegalMenu.switchTab(tab.dataset.tab));
    });

    // Search input
    document.getElementById('menu-search-input')?.addEventListener('input', e => IllegalMenu.handleSearchInput(e.target.value));

    // Clear search
    document.getElementById('menu-search-clear')?.addEventListener('click', () => IllegalMenu.clearSearch());

    // Save recent search on form submit
    document.getElementById('menu-search-form')?.addEventListener('submit', () => {
      const q = document.getElementById('menu-search-input')?.value.trim();
      if (q) IllegalMenu.addRecentSearch(q);
    });

    // Click suggestion item
    document.addEventListener('click', e => {
      const item = e.target.closest('.menu-search-item');
      if (item && item.dataset.searchTerm) {
        IllegalMenu.addRecentSearch(item.dataset.searchTerm);
        window.location.href = '/search?q=' + encodeURIComponent(item.dataset.searchTerm) + '&type=product';
      }
    });

    // ESC key: close menu
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') IllegalMenu.close();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* ------ PREDICTIVE SEARCH (reusable) ------
   Any <input data-predictive-search="resultsId"> gets a live dropdown.
   Uses Shopify's /search/suggest.json — the same endpoint the menu drawer uses. */
function initPredictiveSearch(input) {
  const results = document.getElementById(input.dataset.predictiveSearch);
  if (!results) return;
  let timer = null;

  const hide = () => { results.innerHTML = ''; results.style.display = 'none'; };

  async function run(query) {
    if (query.length < 2) { hide(); return; }
    try {
      const res = await fetch('/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=6');
      if (!res.ok) { hide(); return; }
      const data = await res.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];

      if (!products.length) {
        results.innerHTML = '<div class="ps-empty">No matches for \u201C' + query + '\u201D</div>';
        results.style.display = 'block';
        return;
      }

      results.innerHTML = products.map(function (p) {
        // identical field handling to the working drawer search
        let imgSrc = p.featured_image || p.image || '';
        if (imgSrc && typeof imgSrc === 'object') imgSrc = imgSrc.url || imgSrc.src || '';
                const imgUrl = imgSrc && imgSrc.startsWith('//') ? 'https:' + imgSrc : imgSrc;
        const img = imgUrl ? '<img src="' + imgUrl + '" alt="" loading="lazy">' : '<span class="ps-noimg"></span>';
        const price = typeof p.price === 'number'
          ? (p.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
          : '$' + p.price;
        return '<a class="ps-row" href="' + p.url + '">' + img +
          '<span class="ps-info"><span class="ps-title">' + p.title + '</span>' +
          '<span class="ps-price">' + price + '</span></span></a>';
      }).join('') +
      '<a class="ps-all" href="/search?q=' + encodeURIComponent(query) + '&type=product">VIEW ALL RESULTS \u2192</a>';
      results.style.display = 'block';
    } catch (e) { console.error('Predictive search:', e); }
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    const q = input.value.trim();
    if (!q) { hide(); return; }
    timer = setTimeout(function () { run(q); }, 250);   // debounce
  });
  input.addEventListener('focus', function () {
    const q = input.value.trim();
    if (q.length >= 2) run(q);
  });
  input.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });
  document.addEventListener('click', function (e) {
    if (!input.contains(e.target) && !results.contains(e.target)) hide();
  });
}

(function initAllPredictiveSearch() {
  function go() {
    document.querySelectorAll('input[data-predictive-search]').forEach(initPredictiveSearch);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();


/* ------ CART DRAWER ------ */
const IllegalCart = {
  open() {
    document.getElementById('cart-overlay')?.classList.add('open');
    document.getElementById('cart-drawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },
  close() {
    document.getElementById('cart-overlay')?.classList.remove('open');
    document.getElementById('cart-drawer')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      this.render(cart);
    } catch (e) {
      console.error('Cart refresh failed:', e);
    }
  },

  render(cart) {
    // Update counts
// Header count lives outside the drawer, so it stays global.
    const headerCount = document.getElementById('header-cart-count');
    if (headerCount) headerCount.textContent = cart.item_count;

    // Everything below MUST be scoped to the drawer. Otherwise, if the cart
    // page template reuses any of these IDs (#cart-lines, #cart-empty, etc.),
    // getElementById returns the cart PAGE element (first in document order)
    // and this renderer overwrites the cart page with drawer markup — which is
    // what made "everything disappear" on quantity change.
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    const drawerCount = drawer.querySelector('#cart-drawer-count');
    if (drawerCount) drawerCount.textContent = cart.item_count;

    const empty = drawer.querySelector('#cart-empty');
    const lines = drawer.querySelector('#cart-lines');
    const foot = drawer.querySelector('#cart-foot');

    if (cart.item_count === 0) {
      if (empty) empty.style.display = '';
      if (lines) lines.innerHTML = '';
      if (foot) foot.style.display = 'none';
      return;
    }

    if (empty) empty.style.display = 'none';
    if (foot) foot.style.display = '';

    // Render line items
    if (lines) {
      lines.innerHTML = cart.items.map(item => `
        <div class="cart-line" data-key="${item.key}">
          <div class="cart-line-img">
            ${item.image ? `<img src="${item.image.replace(/(\.[^.]+)$/, '_160x200$1')}" alt="${item.title}" loading="lazy">` : ''}
          </div>
          <div class="cart-line-info">
            <div class="cart-line-title">${item.product_title}</div>
                        <div class="cart-line-variant">${item.variant_title || ''}</div>
            ${renderLineItemProperties(item.properties)}
            <div class="cart-line-controls">
              <div class="cart-line-stepper">
                <button onclick="IllegalCart.updateItem('${item.key}', ${item.quantity - 1})" aria-label="Decrease">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/></svg>
                </button>
                <span class="cart-line-stepper-val">${item.quantity}</span>
                <button onclick="IllegalCart.updateItem('${item.key}', ${item.quantity + 1})" aria-label="Increase">
                  <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14"/><path d="M12 5v14"/></svg>
                </button>
              </div>
              <button class="cart-line-remove" onclick="IllegalCart.updateItem('${item.key}', 0)">REMOVE</button>
            </div>
          </div>
          <div class="cart-line-price">${formatMoney(item.final_line_price)}</div>
        </div>
      `).join('');
    }

    // Update totals
    // Update totals (scoped to drawer, same reason as above)
    const subtotal = drawer.querySelector('#cart-subtotal');
    const total = drawer.querySelector('#cart-total');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (total) total.textContent = formatMoney(cart.total_price);
  },

  async updateItem(key, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) })
      });

      if (!res.ok) {
        const errText = await res.text();
        console.error('change.js rejected', res.status, 'sent:', key, quantity, 'resp:', errText);
        // Clear the row's loading state but leave it in place.
        const row = document.querySelector(`.cart-line-item[data-key="${key}"]`);
        if (row) row.classList.remove('is-updating', 'is-removing');
        return;
      }

      const cart = await res.json();

      if (quantity === 0 || cart.item_count === 0) {
        window.location.reload();
        return;
      }

      this.render(cart);
    } catch (err) {
      console.error('Cart update failed:', err);
      window.location.reload();
    }
  },

  async addItem(variantId, quantity) {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] })
      });
            await this.refresh();
    } catch (e) {
      console.error('Add to cart failed:', e);
    }
  },

  // Submit the FULL product form so line item properties added by apps
  // (e.g. Bundle Options & Selectors) are sent to Shopify and recorded
  // against the order. Hand-building the payload drops those properties.
  async addFromForm(form) {
    const formData = new FormData(form);

    // Some apps render their selectors as an app block OUTSIDE the <form>.
    // Pull any line item property inputs from the surrounding section too.
    const scope = form.closest('.shopify-section') || document;
    scope.querySelectorAll('[name^="properties["]').forEach((input) => {
      if (form.contains(input)) return; // already serialized
      if ((input.type === 'checkbox' || input.type === 'radio') && !input.checked) return;
      formData.append(input.name, input.value);
    });

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    });

    if (!res.ok) {
      let message = 'Add to cart failed';
      try {
        const data = await res.json();
        if (data && data.description) message = data.description;
      } catch (e) { /* non-JSON error */ }
      throw new Error(message);
    }

       await this.refresh();
  }
};

/* ------ MONEY FORMATTER ------ */
function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

/* ------ LINE ITEM PROPERTIES (bundle contents, customizations, etc.) ------ */
function escapeHtml(value) {
  return String(value).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));
}

function renderLineItemProperties(properties) {
  if (!properties) return '';
  // /cart.js returns properties as an object; older responses use [key, value] pairs.
  const entries = Array.isArray(properties) ? properties : Object.entries(properties);
  const visible = entries.filter(([key, value]) => {
    return value !== '' && value != null && String(key).charAt(0) !== '_';
  });
  if (!visible.length) return '';
  return '<div class="cart-line-props">' + visible.map(([key, value]) =>
    `<div class="cart-line-prop"><span class="cart-line-prop-key">${escapeHtml(key)}:</span> ${escapeHtml(value)}</div>`
  ).join('') + '</div>';
}

/* ------ PRODUCT .js URL NORMALIZER ------
   Shopify appends tracking params (pr_prod_strat, pr_seq, pr_ref_pid, ...) to
   product.url on recommendation/related sections. Liquid builds data-product-url
   as "{{ product.url }}.js", so on those sections the ".js" can land INSIDE a
   query value ("/products/handle?pr_seq=uniform.js") — the endpoint then returns
   HTML, res.json() throws, and the fetch silently fails.

   This strips any query/hash and any stray ".js", then re-appends a clean ".js"
   so every caller hits "/products/handle.js" regardless of tracking params.
   Single source of truth — used by QuickAdd, card swatches, and anywhere else. */
function cleanProductJsUrl(url) {
  if (!url) return '';
  return url.split('?')[0].split('#')[0].replace(/\.js$/, '') + '.js';
}

/* Resize a Shopify CDN image URL to a target width (keeps card downloads small). */
function sizedImageUrl(url, width) {
  if (!url) return url;
  // Drop an existing width param so we don't end up with two.
  const cleaned = url.replace(/([?&])width=\d+/i, '$1').replace(/[?&]$/, '');
  return cleaned.includes('?') ? cleaned + '&width=' + width : cleaned + '?width=' + width;
}

/* ------ CART TOAST ------ */
let cartToastTimer = null;
function showCartToast(title, qty) {
  const toast = document.getElementById('cart-toast');
  const textEl = document.getElementById('cart-toast-text');
  if (!toast || !textEl) return;
  const qtyText = qty > 1 ? qty + 'x ' : '';
  textEl.textContent = qtyText + title.toUpperCase() + ' ADDED';
  clearTimeout(cartToastTimer);
  toast.classList.add('is-visible');
  cartToastTimer = setTimeout(() => { toast.classList.remove('is-visible'); }, 3500);
}

/* ------ TIER LADDER HOVER ------ */
(function() {
  const cards = document.querySelectorAll('.tier-card');
  const grid = document.getElementById('tier-grid') || document.querySelector('.tier-card')?.parentElement;

  function setActive(idx) {
    cards.forEach((c, i) => c.classList.toggle('active', i === idx));
  }
  cards.forEach((card, i) => {
    card.addEventListener('mouseenter', () => setActive(i));
  });
  if (grid) {
    grid.addEventListener('mouseleave', () => setActive(-1));
  }
})();

/* ------ FEATURED COLLECTION PILLS ------------------------------------------
   Pills on the homepage's featured-collection section. Each pill is an <a>
   pointing at /collections/{handle}; this module intercepts the click and
   AJAX-swaps the section's grid by fetching that collection page and lifting
   the first N .product-card nodes out of #cp-product-grid. The collection
   page uses the same product-card snippet as the homepage, so swatch, quick
   add, and card link behavior all work identically on the freshly-injected
   cards (those handlers are document-delegated).

   Failure mode is benign: if the fetch or extraction fails, we leave the grid
   as it is and log — the user can click another pill. If JS doesn't run at
   all, clicking a pill just navigates to that collection page via the href.
   --------------------------------------------------------------------------- */
const FeaturedPills = {
  _bound: false,
  _cache: {}, // handle → array of card outerHTML strings

  init() {
    if (this._bound) return;
    this._bound = true;

    document.addEventListener('click', (e) => {
      const pill = e.target.closest('[data-fc-pill]');
      if (!pill) return;
      // Modified clicks (cmd-click, middle-click) should open the collection
      // page in a new tab, not AJAX-swap. Let them through.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      this.swap(pill);
    });

    // Prefetch on hover. Same idea as the swatch prefetch: by the time someone
    // clicks, the response is usually already cached and the swap is instant.
    document.addEventListener('mouseenter', (e) => {
      const pill = e.target && e.target.closest ? e.target.closest('[data-fc-pill]') : null;
      if (!pill || pill.classList.contains('filter-active')) return;
      this.prefetch(pill.dataset.fcPill);
    }, true);
  },

  // Extract product-card nodes from a collection page response. Tries the
  // known collection-page grid first; falls back to whatever grid contains
  // .product-card children if a theme change ever renamed that ID.
  _extractCards(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    let source = doc.getElementById('cp-product-grid');
    if (!source) {
      const firstCard = doc.querySelector('.product-card');
      source = firstCard ? firstCard.parentElement : null;
    }
    if (!source) return [];
    const cards = source.querySelectorAll(':scope > .product-card');
    return Array.from(cards).map(c => c.outerHTML);
  },

  async prefetch(handle) {
    if (!handle || this._cache[handle]) return;
    try {
      const res = await fetch('/collections/' + encodeURIComponent(handle));
      if (!res.ok) return;
      const html = await res.text();
      this._cache[handle] = this._extractCards(html);
    } catch (err) { /* prefetch failures are silent on purpose */ }
  },

  async swap(pill) {
    const section = pill.closest('[data-fc-section]');
    if (!section) return;
    if (section.dataset.fcSwapping === '1') return; // dedupe rapid clicks

    const handle = pill.dataset.fcPill;
    if (!handle) return;

    const grid = section.querySelector('[data-fc-grid]');
    if (!grid) return;

    const limit = parseInt(section.dataset.fcLimit || '8', 10);

    // Active-state swap is immediate, before the fetch resolves, so the click
    // feels responsive even on a cold cache.
    section.querySelectorAll('[data-fc-pill]').forEach(p =>
      p.classList.toggle('filter-active', p === pill)
    );

    section.dataset.fcSwapping = '1';
    grid.style.transition = 'opacity 0.15s';
    grid.style.opacity = '0.4';

    try {
      let cards = this._cache[handle];
      if (!cards) {
        const res = await fetch('/collections/' + encodeURIComponent(handle));
        if (!res.ok) throw new Error('Featured pill fetch failed: ' + res.status);
        cards = this._extractCards(await res.text());
        this._cache[handle] = cards;
      }
      if (!cards.length) throw new Error('No product cards in collection ' + handle);

      grid.innerHTML = cards.slice(0, limit).join('');
    } catch (err) {
      console.error('Featured pill swap failed:', err);
      // Leave the grid as it was; the user can click another pill to retry.
    } finally {
      grid.style.opacity = '';
      delete section.dataset.fcSwapping;
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => FeaturedPills.init());
} else {
  FeaturedPills.init();
}


/* ------ PRODUCT PAGE —— Full PDP Controller ------ */
const PDP = {
  product: null,
  selectedOptions: {},
  currentImageIndex: 0,
  qty: 1,

  init() {
    const jsonEl = document.getElementById('product-json');
    if (!jsonEl) return;
    this.product = JSON.parse(jsonEl.textContent);
    const form = document.getElementById('product-form');
    if (!form) return;

    // Per-template flag: when the buy button carries data-skip-size-gate, this
    // PDP belongs to a product where size isn't a traditional variant (custom
    // builders, bundle products, app-controlled selection). Treat size as
    // already chosen so the button renders ADD TO CART, the form submits
    // without shaking, and the sticky bars behave normally.
    this.skipSizeGate = document.getElementById('add-to-cart-btn')?.dataset.skipSizeGate === 'true';

    // Set initial selected options — Size starts unselected
    const firstAvailable = this.product.variants.find(v => v.available) || this.product.variants[0];
    const hasSize = this.product.options.includes('Size');
    this.sizeSelected = this.skipSizeGate || !hasSize;
    this.product.options.forEach((opt, i) => {
      if (opt === 'Size' && !this.skipSizeGate) {
        this.selectedOptions[opt] = null;
      } else {
        this.selectedOptions[opt] = firstAvailable['option' + (i + 1)];
      }
    });

    // Force-clear any size pre-selection from Shopify (skip when the gate is
    // bypassed — we want the default selection visible there).
    if (hasSize && !this.skipSizeGate) {
      form.querySelectorAll('.product-option-btn[data-option-name="Size"]').forEach(b => {
        b.classList.remove('is-selected');
      });
      const sizeLabel = document.getElementById('selected-size');
      if (sizeLabel) sizeLabel.textContent = '';
    }

    this.initVariantSwitching(form);
    this.initGallery();
    this.initMobileRail();
    this.initQuantity();
    this.initStickyBars();
    this.initSizeGuideModal();
    this.initStackAndSave();
    this.initFormSubmit(form);
    this.initStickyAddButtons();
    this.updateCtaState();

    // Move rating row inline with price row
    const priceRow = document.getElementById('pdp-price-row');
    const ratingRow = document.getElementById('pdp-rating-row');
    if (priceRow && ratingRow) {
      priceRow.appendChild(ratingRow);
      ratingRow.style.marginTop = '0';
    }
  },

  /* ---- Variant Switching ---- */
  initVariantSwitching(form) {
    const buttons = form.querySelectorAll('.product-option-btn');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        const optName = btn.dataset.optionName;
        const optValue = btn.dataset.optionValue;
        if (btn.disabled) return;
        this.selectedOptions[optName] = optValue;

        // Track size selection
        if (optName === 'Size') {
          this.sizeSelected = true;
          this.updateCtaState();
        }

        // Update button states
        form.querySelectorAll('.product-option-btn[data-option-name="' + optName + '"]').forEach(b => {
          const sel = b.dataset.optionValue === optValue;
          b.classList.toggle('is-selected', sel);
        });

        // Update label
        const label = document.getElementById('selected-' + optName.toLowerCase().replace(/\s+/g, '-'));
        if (label) label.textContent = optValue.toUpperCase();

        this.updateVariant();
      });
    });
  },

  updateVariant() {
    const product = this.product;

    // Find exact variant match (all options selected)
    const variant = product.variants.find(v =>
      product.options.every((opt, i) => v['option' + (i + 1)] === this.selectedOptions[opt])
    );

    // Even without a full variant match, switch images for partial selections (e.g. color picked but no size yet)
    if (!variant) {
      this.switchImageForPartialSelection();
      return;
    }

    const variantInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('product-price');
    const compareEl = document.getElementById('product-compare-price');
    const saveEl = document.getElementById('product-save-pill');
    const addBtn = document.getElementById('add-to-cart-btn');
    const stickyPrice = document.getElementById('pdp-sticky-price');
    const stickyCompare = document.getElementById('pdp-sticky-compare');
    const mobilePrice = document.getElementById('pdp-mobile-price');
    const stickyMeta = document.getElementById('pdp-sticky-meta');

    variantInput.value = variant.id;
    const price = formatMoney(variant.price);

    if (priceEl) priceEl.textContent = price;
    if (stickyPrice) stickyPrice.textContent = price;
    if (mobilePrice) mobilePrice.textContent = price;

    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (priceEl) priceEl.style.color = onSale ? 'var(--blood)' : 'var(--ink)';
    if (stickyPrice) stickyPrice.style.color = onSale ? 'var(--blood)' : 'var(--ink)';
    if (mobilePrice) mobilePrice.style.color = onSale ? 'var(--blood)' : 'var(--ink)';

    if (compareEl) {
      if (onSale) {
        compareEl.textContent = formatMoney(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (stickyCompare) {
      if (onSale) {
        stickyCompare.textContent = formatMoney(variant.compare_at_price);
        stickyCompare.style.display = '';
      } else if (stickyCompare) {
        stickyCompare.style.display = 'none';
      }
    }
    if (saveEl) {
      if (onSale) {
        const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
        saveEl.textContent = 'SAVE ' + pct + '%';
        saveEl.style.display = '';
      } else {
        saveEl.style.display = 'none';
      }
    }

    // Update add to cart buttons (only if size has been selected)
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    if (addBtn && this.sizeSelected) {
      addBtn.disabled = !variant.available;
      const addText = addBtn.dataset.addText || 'ADD TO CART';
      const soldText = addBtn.dataset.soldOutText || 'SOLD OUT';
      addBtn.innerHTML = variant.available ? '<span>' + addText + '</span> ' + arrowSvg : '<span>' + soldText + '</span>';
      addBtn.classList.remove('is-no-size');
    }
    if (this.sizeSelected) {
      const stickyArrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.remove('is-no-size');
          btn.disabled = !variant.available;
          btn.innerHTML = variant.available ? '<span>ADD TO CART</span> ' + stickyArrowSvg : '<span>SOLD OUT</span>';
        }
      });
    }

    // Update sticky meta
    if (stickyMeta) {
      const parts = product.options.map(opt => (this.selectedOptions[opt] || '').toUpperCase());
      stickyMeta.textContent = parts.join(' / ');
    }

    // Update URL
    const url = new URL(window.location);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url);

    // Switch to variant image if it has one
    this.switchToVariantImage(variant);

    this.renderStackCards();
  },

  /* ---- Image switching for partial option selection (e.g. color only, no size yet) ---- */
  switchImageForPartialSelection() {
    const product = this.product;
    // Find any variant that matches the currently selected options (ignoring nulls)
    const partialMatch = product.variants.find(v =>
      product.options.every((opt, i) => {
        const sel = this.selectedOptions[opt];
        return sel === null || sel === undefined || v['option' + (i + 1)] === sel;
      })
    );
    if (partialMatch) {
      this.switchToVariantImage(partialMatch);
    }
  },

  /* ---- Switch gallery to a variant's featured image ---- */
  switchToVariantImage(variant) {
    const imageId = variant.image_id || (variant.featured_image && variant.featured_image.id);
    // Extract image src for fallback matching
    const imageSrc = variant.featured_image
      ? (typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src)
      : null;

    if (!imageId && !imageSrc) return;

    // Helper: extract filename stem from a Shopify CDN URL for fuzzy matching
    const getFileStem = (url) => {
      if (!url) return '';
      return url.split('?')[0].split('/').pop().split('.')[0];
    };

    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    let matched = false;

    // Desktop: try image ID first, then fall back to URL matching
    thumbs.forEach((t, i) => {
      if (matched) return;
      if (imageId && String(t.dataset.imageId) === String(imageId)) {
        this.setMainImage(i);
        matched = true;
      }
    });
    if (!matched && imageSrc) {
      const targetStem = getFileStem(imageSrc);
      thumbs.forEach((t, i) => {
        if (matched) return;
        if (t.dataset.src && getFileStem(t.dataset.src) === targetStem) {
          this.setMainImage(i);
          matched = true;
        }
      });
    }

    // Mobile: scroll rail to matching image
    const rail = document.getElementById('pdp-mobile-rail');
    if (rail) {
      const slides = rail.children;
      for (let i = 0; i < slides.length; i++) {
        const slideId = slides[i].dataset.imageId;
        if (imageId && String(slideId) === String(imageId)) {
          rail.scrollTo({ left: i * rail.offsetWidth, behavior: 'smooth' });
          break;
        }
      }
    }
  },

  /* ---- Gallery ---- */
  initGallery() {
    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    if (!thumbs.length) return;

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        this.setMainImage(parseInt(thumb.dataset.index));
      });
    });

    const prevBtn = document.getElementById('pdp-prev');
    const nextBtn = document.getElementById('pdp-next');
    if (prevBtn) prevBtn.addEventListener('click', () => this.setMainImage(this.currentImageIndex - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => this.setMainImage(this.currentImageIndex + 1));
  },

  setMainImage(index) {
    const thumbs = document.querySelectorAll('#pdp-thumb-rail .pdp-thumb');
    if (!thumbs.length) return;
    const total = thumbs.length;
    index = ((index % total) + total) % total;
    this.currentImageIndex = index;

    const thumb = thumbs[index];
    const mainImg = document.getElementById('pdp-main-img');
    const counter = document.getElementById('pdp-img-idx');

    if (mainImg) {
      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt || '';
        mainImg.style.opacity = '1';
      }, 150);
    }
    if (counter) counter.textContent = String(index + 1).padStart(2, '0');

    // Update sticky bar thumbnail
    const stickyImg = document.getElementById('pdp-sticky-img');
    if (stickyImg && thumb.dataset.src) {
      stickyImg.src = thumb.dataset.src.replace('width=1200', 'width=120');
    }

    thumbs.forEach(t => t.classList.remove('is-selected'));
    thumb.classList.add('is-selected');
    thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  },

  /* ---- Mobile Rail ---- */
  initMobileRail() {
    const rail = document.getElementById('pdp-mobile-rail');
    const dots = document.querySelectorAll('#pdp-dots .pdp-dot');
    if (!rail || !dots.length) return;

    let ticking = false;
    rail.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const idx = Math.round(rail.scrollLeft / rail.offsetWidth);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        ticking = false;
      });
    }, { passive: true });

    dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const idx = parseInt(dot.dataset.index);
        rail.scrollTo({ left: idx * rail.offsetWidth, behavior: 'smooth' });
      });
    });
  },

  /* ---- Quantity ---- */
  initQuantity() {
    const display = document.getElementById('pdp-qty-display');
    const input = document.getElementById('product-qty');
    const minus = document.getElementById('pdp-qty-minus');
    const plus = document.getElementById('pdp-qty-plus');
    if (!display || !input) return;

    const update = (delta) => {
      this.qty = Math.max(1, this.qty + delta);
      display.textContent = this.qty;
      input.value = this.qty;
      if (minus) minus.disabled = this.qty <= 1;
    };

    if (minus) minus.addEventListener('click', () => update(-1));
    if (plus) plus.addEventListener('click', () => update(1));
  },

  /* ---- Sticky Bottom Bars ---- */
  initStickyBars() {
    const ctaWrap = document.getElementById('pdp-cta-wrap');
    const desktopBar = document.getElementById('pdp-desktop-bottom');
    const mobileBar = document.getElementById('pdp-mobile-bottom');
    if (!ctaWrap) return;

    const observer = new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      if (desktopBar) desktopBar.classList.toggle('is-visible', show);
      if (mobileBar) mobileBar.classList.toggle('is-visible', show);
    }, { threshold: 0, rootMargin: '-80px 0px 0px 0px' });
    observer.observe(ctaWrap);
  },

  /* ---- Sticky Add buttons ---- */
  initStickyAddButtons() {
    ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
      const btn = document.getElementById(id);
      if (!btn) return;
      btn.addEventListener('click', async () => {
        if (!this.sizeSelected) {
          const isMobile = id === 'pdp-mobile-add';

          // Choose between "nudge to the inline size grid" and "open the Quick
          // Add popup" based on scroll position. While the in-page (non-sticky)
          // main CTA is still in view or below the fold, the size grid is a
          // cheap scroll away, so we nudge: scroll to it and shake. Only once
          // the user has scrolled PAST the main CTA (it's entirely above the
          // viewport) does the popup earn its place — by then scrolling back up
          // to the grid would be a long trip. Popup is mobile-only; on desktop
          // we always nudge.
          const ctaWrap = document.getElementById('pdp-cta-wrap');
          const scrolledPastMainCta = ctaWrap
            ? ctaWrap.getBoundingClientRect().bottom < 0
            : false;

          if (isMobile && scrolledPastMainCta && this.product) {
            QuickAdd.render(this.product);
            return;
          }

          // Nudge: scroll to the size grid and shake it.
          const grid = document.getElementById('pdp-size-grid');
          if (grid) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => this.shakeSizeGrid(), 400);
          }
          return;
        }
        const form = document.getElementById('product-form');
        btn.disabled = true;
        btn.querySelector('span').textContent = 'ADDING...';
        try {
          await IllegalCart.addFromForm(form);
          showCartToast(this.product ? this.product.title : 'Item', this.qty);
          btn.querySelector('span').textContent = 'ADDED!';
          btn.disabled = false;
          setTimeout(() => { btn.querySelector('span').textContent = 'ADD TO CART'; }, 2000);
        } catch (err) {
          console.error('Sticky add error:', err);
          btn.querySelector('span').textContent = 'ADD TO CART';
          btn.disabled = false;
        }
      });
    });
  },

  /* ---- Size Guide Modal ---- */
  initSizeGuideModal() {
    const backdrop = document.getElementById('pdp-modal-backdrop');
    const modal = document.getElementById('pdp-modal');
    const closeBtn = document.getElementById('pdp-modal-close');
    if (!modal) return;

    const open = () => {
      backdrop?.classList.add('is-open');
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      backdrop?.classList.remove('is-open');
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    document.getElementById('pdp-size-guide-open')?.addEventListener('click', open);
    document.getElementById('pdp-size-guide-open-2')?.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);
  },

  /* ---- CTA State (no size vs ready) ---- */
  updateCtaState() {
    const addBtn = document.getElementById('add-to-cart-btn');
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    if (this.sizeSelected) {
      if (addBtn) {
        addBtn.classList.remove('is-no-size');
        addBtn.disabled = false;
        addBtn.innerHTML = '<span>' + (addBtn.dataset.addText || 'ADD TO CART') + '</span> ' + arrowSvg;
      }
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.remove('is-no-size');
          btn.disabled = false;
          btn.innerHTML = '<span>ADD TO CART</span> ' + arrowSvg;
        }
      });
    } else {
      if (addBtn) {
        addBtn.classList.add('is-no-size');
        addBtn.innerHTML = '<span>SELECT A SIZE</span>';
      }
      ['pdp-sticky-add', 'pdp-mobile-add'].forEach(id => {
        const btn = document.getElementById(id);
        if (btn) {
          btn.classList.add('is-no-size');
          btn.innerHTML = '<span>SELECT A SIZE</span>';
        }
      });
    }
  },

  shakeSizeGrid() {
    const grid = document.getElementById('pdp-size-grid');
    if (!grid) return;
    grid.classList.remove('is-prompted');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        grid.classList.add('is-prompted');
      });
    });
    setTimeout(() => grid.classList.remove('is-prompted'), 700);
  },

  /* ---- Form Submit ---- */
  initFormSubmit(form) {
    const addBtn = document.getElementById('add-to-cart-btn');
    const arrowSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    const checkSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

    // Intercept CTA click — if no size selected, shake instead of submitting
    addBtn?.addEventListener('click', (e) => {
      if (!this.sizeSelected) {
        e.preventDefault();
        e.stopImmediatePropagation();
        this.shakeSizeGrid();

        // Scroll to size grid if not in view
        const grid = document.getElementById('pdp-size-grid');
        if (grid) {
          const rect = grid.getBoundingClientRect();
          if (rect.top < 0 || rect.bottom > window.innerHeight) {
            grid.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => this.shakeSizeGrid(), 400);
          }
        }
        return;
      }
    });

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!this.sizeSelected) {
        this.shakeSizeGrid();
        return;
      }

      addBtn.disabled = true;
      addBtn.innerHTML = '<span>ADDING...</span>';

      try {
        await IllegalCart.addFromForm(form);
        showCartToast(this.product ? this.product.title : 'Item', this.qty);
        addBtn.innerHTML = '<span>ADDED!</span> ' + checkSvg;
      } catch (err) {
        console.error('Add to cart failed:', err);
        addBtn.innerHTML = '<span>TRY AGAIN</span>';
      } finally {
        addBtn.disabled = false;
        setTimeout(() => {
          const addText = addBtn.dataset.addText || 'ADD TO CART';
          addBtn.innerHTML = '<span>' + addText + '</span> ' + arrowSvg;
                }, 2000);
      }
    });
  },

  /* ---- Stack & Save ---- */
  initStackAndSave() {
    this.renderStackCards();
  },

  renderStackCards() {
    const grid = document.getElementById('pdp-stack-grid');
    if (!grid) return;

    const variant = this.product.variants.find(v =>
      this.product.options.every((opt, i) => v['option' + (i + 1)] === this.selectedOptions[opt])
    ) || this.product.variants[0];

    const basePrice = variant.price;
    const tiers = [
      { qty: 1, label: 'JUST ONE', pct: 0 },
      { qty: 2, label: 'STACK 2', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier2 || 10) },
      { qty: 3, label: 'STACK 3', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier3 || 20) },
      { qty: 4, label: 'STACK 4+', pct: parseInt(grid.closest('.pdp-stack')?.dataset.tier4 || 30), best: true }
    ];

    grid.innerHTML = tiers.map(t => {
      const perShirt = Math.round(basePrice * (100 - t.pct) / 100);
      const saved = (basePrice - perShirt) * t.qty;
      return '<div class="pdp-stack-card' + (t.best ? ' is-best' : '') + '">'
        + (t.best ? '<div class="pdp-stack-flag">BEST DEAL</div>' : '')
        + '<div class="pdp-stack-eyebrow">' + t.label + '</div>'
        + '<div class="pdp-stack-tier"><span class="pdp-stack-num">' + t.qty + '</span><span class="pdp-stack-unit">SHIRT' + (t.qty > 1 ? 'S' : '') + '</span></div>'
        + '<div class="pdp-stack-meta">'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">PER SHIRT</span><span class="pdp-stack-value">' + formatMoney(perShirt) + '</span></div>'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">DISCOUNT</span><span class="pdp-stack-value' + (t.pct > 0 ? ' is-discount-pct' : ' is-zero') + '">' + (t.pct > 0 ? t.pct + '%' : '-') + '</span></div>'
        + '<div class="pdp-stack-row"><span class="pdp-stack-label">YOU SAVE</span><span class="pdp-stack-value' + (saved > 0 ? '' : ' is-zero') + '">' + (saved > 0 ? formatMoney(saved) : '-') + '</span></div>'
        + '</div></div>';
    }).join('');
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => PDP.init());
} else {
  PDP.init();
}

/* ------ QUICK ADD MODAL ------ */
const QuickAdd = {
  product: null,
  selected: {},
  quantity: 1,

  open() {
    document.getElementById('quick-add-overlay')?.classList.add('open');
    document.getElementById('quick-add-modal')?.classList.add('open');
    document.body.style.overflow = 'hidden';
  },

  close() {
    document.getElementById('quick-add-overlay')?.classList.remove('open');
    document.getElementById('quick-add-modal')?.classList.remove('open');
    document.body.style.overflow = '';
  },

  getSelectedVariant() {
    if (!this.product || !this.optionNames) return null;
    return this.product.variants.find(v => {
      return this.optionNames.every((opt, i) => {
        return v['option' + (i + 1)] === this.selected[opt];
      });
    });
  },

  colorToCSS(name) {
const map = { 'natural': '#f5f0e1', 'heather gray': '#b0b0b0', 'heather grey': '#b0b0b0', 'sports gray': '#b0b0b0', 'sports grey': '#b0b0b0', 'sport gray': '#b0b0b0', 'sport grey': '#b0b0b0', 'charcoal': '#36454f', 'charcoal heather': '#3d4346', 'forrest green': '#228b22', 'forest green': '#228b22', 'royal': '#4169e1', 'pale pink': '#f4d5d8', 'bone': '#e3dac9', 'sand': '#c2b280', 'cream': '#fffdd0', 'oatmeal': '#d4c9a8', 'irish green': '#009a44','azalea': '#e96ba8', 'true royal': '#1d4ed8', 'tweed': '#8e857b', };    return map[name.toLowerCase()] || name.toLowerCase().replace(/[\s-]+/g, '');
  },

  getProductImage() {
    const p = this.product;
    if (!p) return '';
    if (p.featured_image) return typeof p.featured_image === 'string' ? p.featured_image : p.featured_image.src || '';
    if (p.images && p.images.length > 0) return typeof p.images[0] === 'string' ? p.images[0] : p.images[0].src || '';
    return '';
  },

  updateUI() {
    const variant = this.getSelectedVariant();
    const submitBtn = document.getElementById('quick-add-submit');
    const priceEl = document.getElementById('quick-add-modal-price');

    if (variant && priceEl) {
      priceEl.textContent = (variant.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    }

    // Update image for selected variant
    const imgEl = document.querySelector('#quick-add-image img');
    if (imgEl && variant) {
      let src = '';
      if (variant.featured_image) {
        src = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src || '';
      }
      if (!src && this.product && this.product.images && this.product.images.length > 0) {
        const colorOpt = this.optionNames?.find(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
        const colorVal = colorOpt ? this.selected[colorOpt] : null;
        if (colorVal) {
          const colorLower = colorVal.toLowerCase();
          const matchedImg = this.product.images.find(i => {
            const imgSrc = typeof i === 'string' ? i : i.src || '';
            const alt = typeof i === 'object' ? (i.alt || '') : '';
            return alt.toLowerCase().includes(colorLower) || imgSrc.toLowerCase().includes(colorLower.replace(/\s+/g, '-'));
          });
          if (matchedImg) src = typeof matchedImg === 'string' ? matchedImg : matchedImg.src;
        }
        // Fallback: use variant image_id to find matching image
        if (!src && variant.image_id) {
          const matchById = this.product.images.find(i => {
            return (typeof i === 'object' && i.id === variant.image_id);
          });
          if (matchById) src = typeof matchById === 'string' ? matchById : matchById.src;
        }
      }
      if (src && imgEl.src !== src) {
        imgEl.style.opacity = '0.3';
        const preload = new Image();
        preload.onload = () => {
          imgEl.src = src;
          imgEl.style.opacity = '1';
          // Update the mobile thumbnail HERE — after the preload resolves
          // and the main image src is actually the new one. The standalone
          // thumb update used to run synchronously below, copying the OLD
          // src before the preload completed, which is why the mobile
          // thumbnail never reflected the chosen color.
          const thumbImg = document.querySelector('.quick-add-thumb img');
          if (thumbImg) thumbImg.src = src;
        };
        preload.onerror = () => { imgEl.style.opacity = '1'; };
        preload.src = src;
      }
    }

    // Update color label
    const colorLabel = document.getElementById('quick-add-color-label');
    if (colorLabel) {
      const colorOpt = this.optionNames.find(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
      if (colorOpt && this.selected[colorOpt]) colorLabel.textContent = this.selected[colorOpt];
    }

    if (submitBtn) {
      if (!variant) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'UNAVAILABLE';
      } else if (!variant.available) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'SOLD OUT';
      } else {
        submitBtn.disabled = false;
        submitBtn.innerHTML = 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      }
    }

    // Update selected state on option buttons
    document.querySelectorAll('#quick-add-content .quick-add-option-btn').forEach(btn => {
      const opt = btn.dataset.option;
      const val = btn.dataset.value;
      btn.classList.toggle('selected', this.selected[opt] === val);
    });
  },

  render(product) {
    this.product = product;
    this.selected = {};
    this.quantity = 1;

    // Pre-select first available variant's options
    const firstAvailable = product.variants.find(v => v.available) || product.variants[0];
    if (!firstAvailable) return;

    // Normalize options — Shopify .js returns objects like {name: "Size", ...}
    const optionNames = product.options.map(opt => typeof opt === 'string' ? opt : opt.name);

    optionNames.forEach((opt, i) => {
      this.selected[opt] = firstAvailable['option' + (i + 1)];
    });

    // Store normalized option names for variant matching
    this.optionNames = optionNames;

    // Get image — prefer selected variant image, fall back to product image
    let imageSrc = '';
    if (firstAvailable.featured_image) {
      imageSrc = typeof firstAvailable.featured_image === 'string' ? firstAvailable.featured_image : firstAvailable.featured_image.src || '';
    }
    if (!imageSrc) imageSrc = this.getProductImage();

    const image = imageSrc
      ? `<img src="${imageSrc}" alt="${product.title}">`
      : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;opacity:0.3;font-family:monospace;font-size:12px;">NO IMAGE</div>`;

    const price = (firstAvailable.price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    const comparePrice = firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price
      ? (firstAvailable.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
      : '';

    // Build option pickers
    let optionsHTML = '';
    let hasSizeOption = false;
    const hasRealOptions = !(product.variants.length === 1 && product.variants[0].title === 'Default Title');
    if (hasRealOptions) {
      optionNames.forEach((opt, i) => {
        const values = [...new Set(product.variants.map(v => v['option' + (i + 1)]))];
        const isColor = opt.toLowerCase() === 'color' || opt.toLowerCase() === 'colour';
        const isSize = opt.toLowerCase() === 'size';
        if (isSize) hasSizeOption = true;

        if (isColor) {
          const selectedVal = this.selected[opt];
          optionsHTML += `
            <div class="quick-add-option-group">
              <div class="quick-add-option-label">${opt.toUpperCase()}: <span id="quick-add-color-label" style="color: var(--blood);">${selectedVal}</span></div>
              <div class="quick-add-option-values">
                ${values.map(val => {
                  const isSelected = this.selected[opt] === val;
                  const cssColor = this.colorToCSS(val);
                  return `<button type="button" class="quick-add-option-btn quick-add-swatch${isSelected ? ' selected' : ''}" data-option="${opt}" data-value="${val}" style="background: ${cssColor}; border: 1.5px solid var(--ink);" title="${val}"></button>`;
                }).join('')}
              </div>
            </div>`;
        } else {
          optionsHTML += `
            <div class="quick-add-option-group">
              <div class="quick-add-option-label" style="display: flex; justify-content: space-between; align-items: baseline;">${opt.toUpperCase()}</div>
              <div class="quick-add-option-values${isSize ? ' is-size-grid' : ''}">
                ${values.map(val => {
                  const isSelected = this.selected[opt] === val;
                  return `<button type="button" class="quick-add-option-btn${isSelected ? ' selected' : ''}" data-option="${opt}" data-value="${val}" style="border: 1.5px solid var(--ink);">${val}</button>`;
                }).join('')}
              </div>
            </div>`;
        }
      });
    }

    // Determine initial button text
    const sizeSelected = !hasSizeOption || this.selected['Size'];
    const submitText = sizeSelected
      ? 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>'
      : 'SELECT A SIZE';

    const content = document.getElementById('quick-add-content');
    content.innerHTML = `
      <div class="quick-add-product-header">
        <div class="quick-add-thumb">${image}</div>
        <div>
          <div class="quick-add-title">${product.title}</div>
          <div class="quick-add-price" style="color: ${comparePrice ? 'var(--blood)' : 'var(--ink)'};" id="quick-add-modal-price-mobile">${price} ${comparePrice ? '<span style="text-decoration:line-through;opacity:0.5;color:var(--ink);font-weight:400;font-size:12px;margin-left:4px;">' + comparePrice + '</span>' : ''}</div>
        </div>
      </div>
      <div class="quick-add-image" id="quick-add-image">${image}</div>
      <div class="quick-add-info">
        <div class="quick-add-header">
          <div class="quick-add-title">${product.title}</div>
          <div class="quick-add-price" id="quick-add-modal-price">${price}</div>
        </div>
        ${optionsHTML}
        <div class="quick-add-qty-row">
          <div class="quick-add-option-label">QUANTITY</div>
          <div class="quick-add-qty-stepper">
            <button type="button" id="quick-add-qty-minus" aria-label="Decrease quantity" disabled>&minus;</button>
            <input type="number" id="quick-add-qty" value="1" min="1" readonly>
            <button type="button" id="quick-add-qty-plus" aria-label="Increase quantity">&#43;</button>
          </div>
        </div>
        <button type="button" class="quick-add-submit" id="quick-add-submit">
          ${submitText}
        </button>
      </div>`;

    this.open();
  },

  async addToCart() {
    const variant = this.getSelectedVariant();
    if (!variant || !variant.available) return;

    const btn = document.getElementById('quick-add-submit');
    const qtyInput = document.getElementById('quick-add-qty');
    const qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    btn.disabled = true;
    btn.textContent = 'ADDING...';

    try {
      await IllegalCart.addItem(variant.id, qty);
      btn.innerHTML = 'ADDED! <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      setTimeout(() => { this.close(); }, 600);
      showCartToast(this.product ? this.product.title : 'Item', qty);
    } catch (err) {
      console.error('Quick Add cart error:', err);
      btn.disabled = false;
      btn.innerHTML = 'ADD TO CART <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    }
  }
};

// Delegated event listeners for quick add — use capture phase so we beat the link
document.addEventListener('click', (e) => {
  // Quantity stepper buttons
  if (e.target.closest('#quick-add-qty-minus')) {
    const input = document.getElementById('quick-add-qty');
    if (input) {
      input.value = Math.max(1, parseInt(input.value) - 1);
      document.getElementById('quick-add-qty-minus').disabled = parseInt(input.value) <= 1;
    }
    return;
  }
  if (e.target.closest('#quick-add-qty-plus')) {
    const input = document.getElementById('quick-add-qty');
    if (input) {
      input.value = parseInt(input.value) + 1;
      document.getElementById('quick-add-qty-minus').disabled = false;
    }
    return;
  }

  // Open modal from product card
  const trigger = e.target.closest('.quick-add-trigger');
  if (trigger) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    const rawUrl = trigger.dataset.productUrl;
    if (!rawUrl) return;
    // Normalize via the shared helper — on recommendation sections product.url
    // carries pr_* tracking params, so "{{ product.url }}.js" can put ".js"
    // inside a query value. cleanProductJsUrl() always yields /products/handle.js.
    const productUrl = cleanProductJsUrl(rawUrl);

    trigger.disabled = true;
    const origHTML = trigger.innerHTML;
    const isFab = trigger.classList.contains('quick-add-fab');
    if (!isFab) {
      trigger.innerHTML = '<span class="font-mono text-xs tracking-widest flex items-center justify-center gap-2"><span style="width:8px;height:8px;border-radius:9999px;border:1.5px solid var(--bone);border-top-color:transparent;display:inline-block;animation:cp-pulse 0.8s linear infinite;"></span> ADDING</span>';
    } else {
      trigger.style.opacity = '0.5';
    }

    fetch(productUrl)
      .then(res => {
        if (!res.ok) throw new Error('Failed to load product');
        return res.json();
      })
      .then(product => {
        QuickAdd.render(product);
        trigger.disabled = false;
        trigger.innerHTML = origHTML;
        if (isFab) trigger.style.opacity = '';
      })
      .catch(err => {
        console.error('Quick Add error:', err, productUrl);
        if (!isFab) trigger.innerHTML = 'ERROR';
        setTimeout(() => {
          trigger.disabled = false;
          trigger.innerHTML = origHTML;
          if (isFab) trigger.style.opacity = '';
        }, 2000);
      });
    return;
  }

  // Option button click
  const optBtn = e.target.closest('.quick-add-option-btn');
  if (optBtn) {
    e.preventDefault();
    QuickAdd.selected[optBtn.dataset.option] = optBtn.dataset.value;
    QuickAdd.updateUI();
    return;
  }

  // Submit button click
  if (e.target.closest('#quick-add-submit')) {
    e.preventDefault();
    QuickAdd.addToCart();
    return;
  }
}, true); // capture phase

/* ------ CARD COLOR SWATCH SWITCHING ------ */
(function() {
  const productCache = {};
  const inFlight = {};

  // Fetch + cache a product's .js payload. Safe to call repeatedly (e.g. on
  // hover prefetch AND on click) — concurrent calls share one in-flight promise
  // and resolved results are cached, so a click after a hover resolves instantly.
  function fetchProduct(url) {
    const clean = cleanProductJsUrl(url);
    if (!clean) return Promise.resolve(null);
    if (productCache[clean]) return Promise.resolve(productCache[clean]);
    if (inFlight[clean]) return inFlight[clean];

    inFlight[clean] = fetch(clean)
      .then(res => (res.ok ? res.json() : null))
      .then(data => {
        if (data) productCache[clean] = data;
        delete inFlight[clean];
        return data;
      })
      .catch(err => {
        console.error('Swatch product fetch error:', err, clean);
        delete inFlight[clean];
        return null;
      });

    return inFlight[clean];
  }

  // ── PREFETCH ──────────────────────────────────────────────────────────────
  // By the time someone clicks a swatch, their cursor (or finger) was already on
  // the card. Warm the cache then, so the click resolves with no network wait.
  // Capture phase: mouseenter doesn't bubble, so we catch it as it descends.
  function warmCardCache(target) {
    const card = target && target.closest ? target.closest('.product-card') : null;
    if (!card) return;
    const swatch = card.querySelector('.card-swatch[data-product-url]');
    if (swatch) fetchProduct(swatch.dataset.productUrl); // fire-and-forget
  }
  document.addEventListener('mouseenter', (e) => warmCardCache(e.target), true);
  document.addEventListener('touchstart', (e) => warmCardCache(e.target), { passive: true });

  // ── CLICK ───────────────────────────────────────────────────────────────────
  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('.card-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    const card = swatch.closest('.product-card');
    if (!card) return;
    if (swatch.classList.contains('is-active')) return; // already selected

    const color = swatch.dataset.color;
    const productUrl = swatch.dataset.productUrl;
    if (!color || !productUrl) return;

    // Update active swatch immediately
    card.querySelectorAll('.card-swatch').forEach(s => s.classList.remove('is-active'));
    swatch.classList.add('is-active');

    const product = await fetchProduct(productUrl);
    if (!product) return;

    // Find option index for Color
    const optionNames = product.options.map(opt => typeof opt === 'string' ? opt : opt.name);
    const colorIndex = optionNames.findIndex(o => o.toLowerCase() === 'color' || o.toLowerCase() === 'colour');
    if (colorIndex === -1) return;

    // Find first available variant with this color
    const variant = product.variants.find(v => v['option' + (colorIndex + 1)] === color && v.available)
      || product.variants.find(v => v['option' + (colorIndex + 1)] === color);
    if (!variant) return;

    // Swap image - try variant featured_image first, then search product images by alt text or color name
    const img = card.querySelector('.product-card-img');
    if (img) {
      let newSrc = null;
      let newAlt = product.title;
      if (variant.featured_image) {
        newSrc = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src;
        newAlt = (typeof variant.featured_image === 'object' && variant.featured_image.alt) || product.title;
      }
      if (!newSrc && product.images && product.images.length > 0) {
        const colorLower = color.toLowerCase();
        const matchedImg = product.images.find(i => {
          const src = typeof i === 'string' ? i : i.src || '';
          const alt = typeof i === 'object' ? (i.alt || '') : '';
          return alt.toLowerCase().includes(colorLower) || src.toLowerCase().includes(colorLower.replace(/\s+/g, '-'));
        });
        if (matchedImg) {
          newSrc = typeof matchedImg === 'string' ? matchedImg : matchedImg.src;
          newAlt = (typeof matchedImg === 'object' && matchedImg.alt) || product.title;
        }
      }
      if (newSrc) {
        // The card renders at ~600px; the .js payload hands back the full-res
        // original. Request a card-sized image so the download + decode is small.
        const sized = sizedImageUrl(newSrc, 600);

        // Decode off-screen, then hard-swap with no blank gap. (Old approach
        // set opacity:0 and faded back in only after load, so the card went
        // empty for the whole download — that was most of the visible lag.)
        const next = new Image();
        next.src = sized;
        const apply = () => { img.src = sized; img.alt = newAlt; };
        if (next.decode) {
          next.decode().then(apply).catch(apply);
        } else {
          next.onload = apply;
          next.onerror = apply;
        }
      }
    }

    // Clean base for variant deep-links (strip tracking params + .js once).
    const base = cleanProductJsUrl(productUrl).replace(/\.js$/, '');

    // Update product link to point to variant
    const link = card.querySelector('.product-card-link');
    if (link) link.href = base + '?variant=' + variant.id;

    // Update title link too
    const titleLink = card.querySelector('.pt-4 a.font-display');
    if (titleLink) titleLink.href = base + '?variant=' + variant.id;

    // Update price
    const priceEl = card.querySelector('.font-mono.text-sm.font-bold');
    if (priceEl && typeof formatMoney === 'function') {
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (onSale) {
        priceEl.innerHTML = '<span class="flex flex-col items-end">'
          + '<span style="color: var(--blood);">' + formatMoney(variant.price) + '</span>'
          + '<span style="text-decoration: line-through; opacity: 0.5; font-weight: normal; font-size: 11px;">' + formatMoney(variant.compare_at_price) + '</span>'
          + '</span>';
      } else {
        priceEl.innerHTML = formatMoney(variant.price);
        priceEl.style.color = 'var(--ink)';
      }
    }
  });
})();

/* ------ INIT: Refresh cart state on load ------ */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => IllegalCart.refresh());
} else {
  IllegalCart.refresh();
}

/* ============================================================
   COLLECTION PAGE — Tag-based AJAX filtering, no full reloads

   MODEL: every facet (pills, color, size, product type, tags) is a
   tag-based URL. Shopify stacks tags with "+":
     /collections/all                 (no filters)
     /collections/all/sale            (one tag)
     /collections/all/sale+black+xl   (multiple tags, AND)

   Clicking any facet TOGGLES one tag in that +-joined segment and
   AJAX-swaps the whole #cp-section. Sort + pagination params are
   preserved across swaps. Cross-collection links navigate normally.
   ============================================================ */

const CollectionPage = {
  priceTimeout: null,
  _infiniteObserver: null,
  _swapping: false,
  _ajaxBound: false,
  _gridResizeBound: false,
  _sortDocBound: false,

  init() {
    if (!document.getElementById('cp-section')) return;
    this.initSortDropdowns();
    this.initFilterButtons();
    this.initPriceInputs();
    this.initMobileDrawer();
    this.initClearPriceChips();
    this.initResponsiveGrid();
    this.initInfiniteScroll();
    this.initLoadMoreButton();
    this.initAjaxFilters();
  },

  /* ============================================================
     TAG PATH HELPERS
     ============================================================ */

  /* Parse the +-joined tag segment out of a collection path.
     "/collections/all/sale+black" with base "/collections/all"
     -> ["sale", "black"]. Returns [] for the bare collection URL. */
  tagsFromPath(pathname, base) {
    if (!base || pathname === base || !pathname.startsWith(base + '/')) return [];
    const seg = pathname.slice(base.length + 1).split('/')[0]; // first path segment after base
    if (!seg) return [];
    return seg.split('+').map(decodeURIComponent).filter(Boolean);
  },

  /* Build a collection URL from a base + array of tags + a search string. */
  buildTagUrl(base, tags, search) {
    const path = tags.length ? base + '/' + tags.map(encodeURIComponent).join('+') : base;
    return path + (search || '');
  },

  /* The current sort/page-free query string, used to preserve sort + active
     storefront filters across a SAME-collection swap (tag toggle, sort change). */
  currentSearch() {
    const u = new URL(window.location);
    u.searchParams.delete('page'); // never carry pagination across a filter change
    return u.search;
  },

  /* Sort-only query string. Used when a collection PILL switches collections:
     sort is a user preference worth keeping, but storefront filters (filter.*)
     and any price range belong to the OLD collection and must be dropped. */
  sortOnlySearch() {
    const cur = new URL(window.location);
    const out = new URLSearchParams();
    const sort = cur.searchParams.get('sort_by');
    if (sort) out.set('sort_by', sort);
    const s = out.toString();
    return s ? '?' + s : '';
  },

  /* ============================================================
     SORT DROPDOWN
     ============================================================ */
  initSortDropdowns() {
    // Per-trigger listeners: safe to (re)bind, the trigger nodes are replaced
    // on each section swap so old listeners are discarded with the old nodes.
    document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(trigger => {
      const wrapper = trigger.closest('[id^="cp-sort-wrapper"]');
      const panel = wrapper?.querySelector('[id^="cp-sort-panel"]');
      if (!panel) return;

      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = !panel.classList.contains('hidden');
        document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));
        if (!isOpen) {
          panel.classList.remove('hidden');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Document-level listeners bind ONCE — re-running initSortDropdowns after
    // a swap must not stack duplicate document handlers.
    if (this._sortDocBound) return;
    this._sortDocBound = true;

    // Sort option click
    document.addEventListener('click', (e) => {
      const opt = e.target.closest('.cp-sort-option');
      if (!opt) return;
      e.preventDefault();
      e.stopPropagation();
      const sortValue = opt.dataset.sortValue;
      if (!sortValue) return;

      // Update active state visually on ALL panels
      document.querySelectorAll('.cp-sort-option').forEach(o => {
        o.classList.remove('is-active');
        o.setAttribute('aria-selected', 'false');
      });
      document.querySelectorAll('.cp-sort-option[data-sort-value="' + sortValue + '"]').forEach(o => {
        o.classList.add('is-active');
        o.setAttribute('aria-selected', 'true');
      });

      // Update ALL trigger texts (desktop + mobile)
      const sortLabels = { 'manual': 'FEATURED', 'best-selling': 'BEST SELLING', 'created-descending': 'NEWEST', 'price-ascending': 'LOW-HIGH', 'price-descending': 'HIGH-LOW', 'title-ascending': 'A-Z' };
      const newLabel = sortLabels[sortValue] || 'FEATURED';
      document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(trigger => {
        const spans = trigger.querySelectorAll(':scope > span');
        if (spans.length >= 2) spans[1].textContent = newLabel;
      });

      // Close all panels
      document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));

      // Sort changes are an AJAX swap too — keep current tags, set sort_by.
      const url = new URL(window.location);
      if (sortValue === 'manual') {
        url.searchParams.delete('sort_by');
      } else {
        url.searchParams.set('sort_by', sortValue);
      }
      url.searchParams.delete('page');
      const target = url.pathname + url.search;
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });

    // Close panels on outside click
    document.addEventListener('click', (e) => {
      if (e.target.closest('.cp-sort-panel') || e.target.closest('[id^="cp-sort-trigger"]')) return;
      document.querySelectorAll('.cp-sort-panel').forEach(p => p.classList.add('hidden'));
      document.querySelectorAll('[id^="cp-sort-trigger"]').forEach(t => t.setAttribute('aria-expanded', 'false'));
    });
  },

  /* ============================================================
     STOREFRONT FILTER BUTTONS (Search & Discovery <button data-param>)
     Only fire if you actually have storefront filters configured.
     Tag-based stores mostly use the <a href> path below instead, but
     this stays correct for any real ?filter.* facets.
     ============================================================ */
  initFilterButtons() {
    if (this._filterBtnBound) return;
    this._filterBtnBound = true;

    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cp-filter-value');
      if (!btn) return;
      e.preventDefault();

      const param = btn.dataset.param;
      const value = btn.dataset.value;
      const isActive = btn.dataset.active === 'true';

      const url = new URL(window.location);

      if (isActive) {
        const existing = url.searchParams.getAll(param);
        url.searchParams.delete(param);
        existing.filter(v => v !== value).forEach(v => url.searchParams.append(param, v));
      } else {
        url.searchParams.append(param, value);
      }

      url.searchParams.delete('page');
      const target = url.pathname + url.search;
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });
  },

  /* ============================================================
     PRICE RANGE INPUTS (storefront price filter)
     ============================================================ */
  initPriceInputs() {
    document.querySelectorAll('.cp-price-filter').forEach(input => {
      // Guard against double-binding after a swap by tagging bound inputs.
      if (input._cpBound) return;
      input._cpBound = true;

      input.addEventListener('change', () => {
        clearTimeout(this.priceTimeout);
        this.priceTimeout = setTimeout(() => this.submitPriceFilter(), 600);
      });

      input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this.submitPriceFilter();
        }
      });
    });
  },

  submitPriceFilter() {
    const url = new URL(window.location);
    const seen = {};
    document.querySelectorAll('.cp-price-filter').forEach(input => {
      const param = input.dataset.param;
      if (seen[param]) return;
      const val = input.value.trim();
      if (val) {
        url.searchParams.set(param, val);
        seen[param] = true;
      } else {
        url.searchParams.delete(param);
      }
    });
    url.searchParams.delete('page');
    const target = url.pathname + url.search;
    this.swapToUrl(target, true).catch(() => { window.location = target; });
  },

  /* ============================================================
     CLEAR PRICE CHIP
     ============================================================ */
  initClearPriceChips() {
    document.querySelectorAll('.cp-clear-price').forEach(btn => {
      if (btn._cpBound) return;
      btn._cpBound = true;
      btn.addEventListener('click', () => {
        const url = new URL(window.location);
        url.searchParams.delete(btn.dataset.minParam);
        url.searchParams.delete(btn.dataset.maxParam);
        url.searchParams.delete('page');
        const target = url.pathname + url.search;
        this.swapToUrl(target, true).catch(() => { window.location = target; });
      });
    });
  },

  /* ============================================================
     MOBILE FILTER DRAWER
     ============================================================ */
  initMobileDrawer() {
    const backdrop = document.getElementById('cp-mobile-backdrop');
    const drawer = document.getElementById('cp-mobile-drawer');
    const openBtn = document.getElementById('cp-mobile-filter-open');
    const closeBtn = document.getElementById('cp-mobile-filter-close');
    const showBtn = document.getElementById('cp-mobile-show-results');

    if (!drawer) return;

    const open = () => {
      backdrop?.classList.add('is-open');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const close = () => {
      backdrop?.classList.remove('is-open');
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    // These bind to specific elements that are replaced on swap, so re-running
    // is correct. Expose close() so swapToUrl can shut the drawer after a pick.
    openBtn?.addEventListener('click', open);
    closeBtn?.addEventListener('click', close);
    showBtn?.addEventListener('click', close);
    backdrop?.addEventListener('click', close);
    this._closeMobileDrawer = close;
  },

  /* ============================================================
     RESPONSIVE GRID COLUMNS
     ============================================================ */
  initResponsiveGrid() {
    const apply = () => {
      const grid = document.getElementById('cp-product-grid');
      if (!grid) return;
      const deskCols = grid.dataset.desktopCols || '4';
      const mobCols = grid.dataset.mobileCols || '2';
      const cols = window.innerWidth >= 1024 ? deskCols : mobCols;
      grid.style.gridTemplateColumns = 'repeat(' + cols + ', minmax(0, 1fr))';
    };
    apply();
    if (!this._gridResizeBound) {
      window.addEventListener('resize', apply, { passive: true });
      this._gridResizeBound = true;
    }
  },

  /* ============================================================
     PAGINATION — Load More / Infinite Scroll
     ============================================================ */
  async fetchNextPage(nextUrl) {
    try {
      const response = await fetch(nextUrl);
      if (!response.ok) throw new Error('Load failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');

      const newGrid = doc.getElementById('cp-product-grid');
      const currentGrid = document.getElementById('cp-product-grid');
      if (newGrid && currentGrid) {
        currentGrid.insertAdjacentHTML('beforeend', newGrid.innerHTML);
      }

      const newSentinel = doc.getElementById('cp-load-more-sentinel');
      const newBtn = doc.getElementById('cp-load-more-btn');
      const newNextUrl = (newSentinel && newSentinel.dataset.nextUrl) || (newBtn && newBtn.dataset.nextUrl);

      return newNextUrl || null;
    } catch (err) {
      console.error('Load more error:', err);
      return nextUrl; // return same URL to allow retry
    }
  },

  initInfiniteScroll() {
    // Tear down any prior observer so re-running after a swap doesn't stack
    // duplicate observers (which would double-fetch).
    if (this._infiniteObserver) {
      this._infiniteObserver.disconnect();
      this._infiniteObserver = null;
    }

    const sentinel = document.getElementById('cp-load-more-sentinel');
    if (!sentinel) return;

    this._infiniteObserver = new IntersectionObserver(async (entries) => {
      if (!entries[0].isIntersecting) return;

      const nextUrl = sentinel.dataset.nextUrl;
      if (!nextUrl) return;

      sentinel.dataset.nextUrl = '';

      const newNextUrl = await this.fetchNextPage(nextUrl);
      if (newNextUrl) {
        sentinel.dataset.nextUrl = newNextUrl;
      } else {
        sentinel.remove();
        const indicator = document.getElementById('cp-loading-indicator');
        if (indicator) {
          const count = document.querySelectorAll('#cp-product-grid .product-card').length;
          indicator.innerHTML = '<span class="font-mono text-[10px] tracking-[0.3em] opacity-40">END OF THE LINE \u00B7 ' + count + ' DESIGNS</span>';
        }
      }
    }, { rootMargin: '400px' });

    this._infiniteObserver.observe(sentinel);
  },

  initLoadMoreButton() {
    const btn = document.getElementById('cp-load-more-btn');
    if (!btn) return;

    // The button node is replaced on swap, so binding here is fine.
    btn.addEventListener('click', async () => {
      const nextUrl = btn.dataset.nextUrl;
      if (!nextUrl) return;

      btn.dataset.nextUrl = '';
      btn.textContent = 'LOADING...';
      btn.style.opacity = '0.5';
      btn.style.pointerEvents = 'none';

      const newNextUrl = await this.fetchNextPage(nextUrl);
      if (newNextUrl) {
        btn.dataset.nextUrl = newNextUrl;
        btn.textContent = btn.dataset.originalText || 'LOAD MORE';
        btn.style.opacity = '';
        btn.style.pointerEvents = '';
      } else {
        const count = document.querySelectorAll('#cp-product-grid .product-card').length;
        btn.parentElement.innerHTML = '<span class="font-mono text-[10px] tracking-[0.3em] opacity-40">END OF THE LINE \u00B7 ' + count + ' DESIGNS</span>';
      }
    });

    btn.dataset.originalText = btn.textContent.trim();
  },

  /* ============================================================
     AJAX FILTER LINKS — two behaviors, both swap with no reload:

     1. COLLECTION PILLS (links tagged data-cp-collection-pill):
        navigate to that collection's grid in place. SALE is its own
        collection (/collections/sale), so the pill swaps the whole
        section to that collection. Because collections can't stack on
        each other, picking a pill REPLACES the collection context — any
        tag refinement from the previous collection is dropped (there is
        no /collections/sale+new in Shopify). Sidebar checkboxes then
        refine WITHIN whatever collection the pill landed on.

     2. SAME-COLLECTION TAG LINKS (facet fallbacks, chips, the ALL pill):
        toggle one tag in the +-joined path of the CURRENT collection.

     Anything pointing at an unrelated collection that ISN'T a pill (or a
     category tile) navigates normally with a real page load.
     ============================================================ */
  initAjaxFilters() {
    if (this._ajaxBound) return;
    this._ajaxBound = true;

    document.addEventListener('click', (e) => {
      if (e.defaultPrevented) return;
      // Let modified clicks (new tab / new window) behave normally.
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;

      const section = document.getElementById('cp-section');
      if (!section) return;

      const link = e.target.closest('a[href]');
      if (!link || !section.contains(link)) return;

      // Never hijack: category tiles (real page changes) or sort options.
      if (link.closest('.cp-tile') || link.closest('.cp-sort-panel')) return;

      let dest;
      try { dest = new URL(link.getAttribute('href'), window.location.origin); }
      catch (err) { return; }
      if (dest.origin !== window.location.origin) return;
      if (dest.pathname.includes('/products/')) return;

      // ── Verbatim filter URL: swap to the href exactly as given ──
      // Storefront filter chip "remove" links use Shopify's url_to_remove,
      // which is the canonical URL with that one filter value stripped.
      // Swap to it as-is; do NOT run it through tag-toggle logic (it has
      // filter.* params and no tag segment to toggle).
      if (link.hasAttribute('data-cp-filter-url')) {
        const u = new URL(link.getAttribute('href'), window.location.origin);
        u.searchParams.delete('page');
        const target = u.pathname + u.search;
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Clear-all: strip EVERYTHING (tags, storefront filters, price) ──
      // Marked with data-cp-clear-all. Swaps to the bare collection path,
      // keeping only sort. This is what the CLEAR ALL chip and the sidebar/
      // drawer "clear" links use. Without this they'd fall through to the
      // tag-toggle branch, which clears tags but LEAVES filter.* params —
      // the bug where clicking CLEAR ALL appeared to do nothing.
      if (link.hasAttribute('data-cp-clear-all')) {
        const target = dest.pathname + this.sortOnlySearch();
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Collection pill: swap to that collection, no tag carry-over ──
      // Marked in Liquid with data-cp-collection-pill. The href is the
      // target collection URL (its own canonical path). We swap straight
      // to it. Sort is preserved; tags from the old collection are NOT
      // (they're meaningless against a different collection).
      if (link.hasAttribute('data-cp-collection-pill')) {
        const target = dest.pathname + this.sortOnlySearch();
        e.preventDefault();
        this.swapToUrl(target, true).catch(() => { window.location = target; });
        return;
      }

      // ── Same-collection tag toggle ──
      // Facet fallbacks, chips, and the ALL pill operate on the CURRENT
      // collection only. A link to a different collection that ISN'T a
      // pill falls through to a normal navigation.
      const base = section.dataset.collectionUrl || '';
      const sameCollection = base &&
        (dest.pathname === base || dest.pathname.startsWith(base + '/'));
      if (!sameCollection) return;

      // Figure out which tag this link represents, then toggle it against the
      // live URL's tag set. We recompute instead of trusting the link's href:
      // the Liquid fallbacks only encode a single-tag toggle and drop the rest,
      // which is exactly what was navigating you to a stripped-down view.
      const linkTags = this.tagsFromPath(dest.pathname, base);
      const curTags = this.tagsFromPath(window.location.pathname, base);

      let nextTags;
      if (linkTags.length === 0) {
        // Bare collection URL = a CLEAR-ALL / clear link. Empty the tag set.
        nextTags = [];
      } else {
        // The tag being toggled is the last segment the link adds.
        const tag = linkTags[linkTags.length - 1];
        nextTags = curTags.includes(tag)
          ? curTags.filter(t => t !== tag)   // already on -> remove
          : curTags.concat(tag);             // not on   -> add
      }

      const target = this.buildTagUrl(base, nextTags, this.currentSearch());

      e.preventDefault();
      this.swapToUrl(target, true).catch(() => { window.location = target; });
    });

    // Back / forward re-run the swap against whatever the URL now is.
    window.addEventListener('popstate', () => {
      this.swapToUrl(window.location.pathname + window.location.search, false)
        .catch(() => window.location.reload());
    });
  },

  /* ============================================================
     THE SWAP — fetch a collection/tag/filter URL and replace the
     whole #cp-section. Updates header, sticky pills (active states),
     chips, grid, pagination, sidebar + drawer facets in one shot.
     ============================================================ */
  async swapToUrl(url, push) {
    // In-flight guard: ignore a new request while one runs. (async fn, so this
    // still returns a resolved promise — callers can .catch safely.)
    if (this._swapping) return;
    this._swapping = true;

    const liveSection = document.getElementById('cp-section');
    const grid = document.getElementById('cp-product-grid');
    if (grid) grid.style.opacity = '0.4';

    try {
      const response = await fetch(url, { headers: { 'X-Requested-With': 'fetch' } });
      if (!response.ok) throw new Error('Filter fetch failed: ' + response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const freshSection = doc.getElementById('cp-section');
      if (!freshSection || !liveSection) throw new Error('No #cp-section in response');

      // Preserve which sidebar/drawer facets the user had expanded.
      const openFacets = this.snapshotDetails();

      // Replace the entire section's innards in one shot. Correct whether we
      // filtered the current collection or just changed sort.
      liveSection.innerHTML = freshSection.innerHTML;
      liveSection.dataset.collectionUrl =
        freshSection.dataset.collectionUrl || liveSection.dataset.collectionUrl;

      this.restoreDetails(openFacets);

      // Re-bind element-specific listeners for the freshly injected markup.
      // (Document-delegated handlers — ajax links, filter buttons, sort options,
      // quick-add — survive because they're bound to `document`.)
      this.initSortDropdowns();
      this.initMobileDrawer();
      this.initResponsiveGrid();
      this.initInfiniteScroll();
      this.initLoadMoreButton();
      this.initPriceInputs();
      this.initClearPriceChips();

      // Close the mobile drawer if it was open (user tapped a filter inside it).
      if (this._closeMobileDrawer) this._closeMobileDrawer();

      // Update the address bar so reload + back/forward work.
      if (push) window.history.pushState({ cpFilter: true }, '', url);

      // After a filter change, nudge the grid into view if the user scrolled past.
      if (push) {
        const anchor = document.getElementById('cp-grid-anchor');
        if (anchor) {
          const top = anchor.getBoundingClientRect().top + window.scrollY - 140;
          if (window.scrollY > top + 40) window.scrollTo({ top, behavior: 'smooth' });
        }
      }
    } finally {
      const g = document.getElementById('cp-product-grid');
      if (g) g.style.opacity = '';
      this._swapping = false;
    }
  },

  /* ---- Remember / restore expanded <details> facets across a swap ---- */
  snapshotDetails() {
    const map = {};
    document.querySelectorAll('#cp-sidebar-facets details.cp-facet, #cp-drawer-facets details.cp-facet')
      .forEach(d => {
        const key = (d.querySelector('summary') || {}).textContent;
        if (key) map[key.trim()] = d.open;
      });
    return map;
  },

  restoreDetails(map) {
    document.querySelectorAll('#cp-sidebar-facets details.cp-facet, #cp-drawer-facets details.cp-facet')
      .forEach(d => {
        const key = ((d.querySelector('summary') || {}).textContent || '').trim();
        if (key in map) d.open = map[key];
      });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CollectionPage.init());
} else {
  CollectionPage.init();
}

/* ============================================================
   CART PAGE — AJAX Controls, Progress Bar, Upsells
   ============================================================ */

const CartPage = {
  thresholdCents: 0,

  init() {
    if (!document.getElementById('cart-page')) return;

    // Parse threshold from settings (injected via Liquid)
    const bar = document.getElementById('cart-shipping-bar');
    this.thresholdCents = parseInt(bar?.dataset?.threshold || '10000');

    this.initQuantityButtons();
    this.initRemoveButtons();
    this.initUpsellRail();
    this.initCloseLinks();
    this.loadRecommendations();

    // Reflect the initial server-rendered quantities in the minus buttons.
    this.syncMinusButtons();
  },

  /* ---- Disable a line's minus button when its qty is 1 ----
     Pass a specific line element to sync just that row, or omit to sync all.
     Visually communicates the floor-at-1 rule instead of silently no-op'ing. */
  syncMinusButtons(scope) {
    const rows = scope
      ? [scope]
      : document.querySelectorAll('#cart-page .cart-line-item');
    rows.forEach(row => {
      if (!row) return;
      const input = row.querySelector('.cart-qty-input');
      const minus = row.querySelector('.cart-qty-btn[data-action="decrease"]');
      if (!input || !minus) return;
      const atMin = (parseInt(input.value, 10) || 1) <= 1;
      minus.disabled = atMin;
      minus.setAttribute('aria-disabled', atMin ? 'true' : 'false');
      minus.classList.toggle('is-disabled', atMin);
    });
  },

  /* ---- Close / Continue Shopping links ----
     Both the desktop "CONTINUE SHOPPING" text link and the mobile X icon
     share .cart-close-link. Default href is "/" (home) as the no-JS fallback.
     With JS, prefer going BACK to where the user came from — but only if the
     referrer is on this same domain, so we never bounce someone off-site
     from clicking a "close" button. Deep links / external referrers / no
     referrer all fall back to home. */
  initCloseLinks() {
    document.querySelectorAll('.cart-close-link').forEach(link => {
      link.addEventListener('click', (e) => {
        // Let modifier clicks (cmd-click, middle-click, etc.) follow the
        // href normally so "open in new tab" still works.
        if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        e.preventDefault();

        if (document.referrer) {
          try {
            const ref = new URL(document.referrer);
            if (ref.origin === window.location.origin) {
              window.history.back();
              return;
            }
          } catch (err) { /* malformed referrer — fall through to home */ }
        }
        window.location.href = '/';
      });
    });
  },

  /* ---- Quantity +/- ---- */
  initQuantityButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-qty-btn');
      if (!btn) return;
      if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      const key = btn.dataset.key;
      const action = btn.dataset.action;
      const lineItem = btn.closest('.cart-line-item');
      const input = lineItem.querySelector('.cart-qty-input');
      if (!input) return;

      let qty = parseInt(input.value) || 1;
      if (action === 'increase') qty++;
      else if (action === 'decrease') qty = qty - 1;

      // Floor at 1. The stepper never removes — that's the REMOVE button's job.
      // Trying to go below 1 is a no-op (and we make sure the input shows 1).
      if (qty < 1) {
        input.value = 1;
        return;
      }

      input.value = qty;
      lineItem.classList.add('is-updating');
      this.syncMinusButtons(lineItem);

      this.updateItem(key, qty);
    });

    // Also handle direct input changes
    document.addEventListener('change', (e) => {
      if (!e.target.classList.contains('cart-qty-input')) return;
      const key = e.target.dataset.key;
      // Floor at 1 — typing 0 (or blank) is not a removal here; use REMOVE.
      const qty = Math.max(1, parseInt(e.target.value, 10) || 1);
      e.target.value = qty;
      const lineItem = e.target.closest('.cart-line-item');
      if (lineItem) lineItem.classList.add('is-updating');
      this.updateItem(key, qty);
    });
  },

  /* ---- Remove button ---- */
  initRemoveButtons() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-line-remove');
      if (!btn) return;

      const key = btn.dataset.key;
      const lineItem = btn.closest('.cart-line-item');
      if (lineItem) lineItem.classList.add('is-removing');
      this.updateItem(key, 0);
    });
  },

  /* ---- AJAX update ---- */
  async updateItem(key, quantity) {
    const qty = Math.max(0, parseInt(quantity, 10) || 0);

    // A removal (qty 0) ends with a full reload anyway, to keep the Liquid-
    // rendered tier banners / progress bar / line list in sync. So DON'T run
    // the optimistic in-place renderers for it — those expect the item to
    // still exist in the returned cart, and against an emptied/edited cart they
    // were painting a broken half-state (line stuck at 0, totals mismatched)
    // in the gap before the reload landed. Post the change, then reload.
    if (qty === 0) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      } catch (err) {
        console.error('Cart remove failed:', err);
      } finally {
        window.location.reload(); // reload regardless — clean state either way
      }
      return;
    }

    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });

      // A non-OK response (e.g. a stale line key) must NOT reach the renderers.
      // Parsing + rendering a malformed/error body is what broke the page.
      if (!res.ok) {
        console.error('change.js rejected', res.status, 'sent:', key, qty);
        const row = document.querySelector(`.cart-line-item[data-key="${key}"]`);
        if (row) row.classList.remove('is-updating', 'is-removing');
        window.location.reload();
        return;
      }

      const cart = await res.json();

      // Defensive: if the server somehow emptied the cart, reload for clean state.
      if (!cart || cart.item_count === 0) {
        window.location.reload();
        return;
      }

      // Update line item price
      this.updateLineItem(key, cart);
      this.updateSummary(cart);
      this.updateProgressBar(cart);
      this.updateStackBar(cart);
      this.updateCounts(cart);

      // Also update the drawer if it exists
      if (typeof IllegalCart !== 'undefined') IllegalCart.render(cart);

    } catch (err) {
      console.error('Cart update failed:', err);
      window.location.reload();
    }
  },

updateLineItem(key, cart) {
    const lineEl = document.querySelector(`.cart-line-item[data-key="${key}"]`);
    if (!lineEl) return;
    lineEl.classList.remove('is-updating', 'is-removing');

    if (!cart || !cart.items) return;

    const item = cart.items.find(i =>
      i.key === key || i.key.split(':')[0] === String(key).split(':')[0]
    );
    if (!item) return;

    if (item.key !== key) {
      lineEl.dataset.key = item.key;
      lineEl.querySelectorAll('[data-key]').forEach(el => { el.dataset.key = item.key; });
    }

    const priceEl = lineEl.querySelector('.cart-line-price');
    if (priceEl) priceEl.textContent = formatMoney(item.final_line_price);

    const qtyInput = lineEl.querySelector('.cart-qty-input');
    if (qtyInput) qtyInput.value = item.quantity;

    // Keep the minus button's disabled state in step with the confirmed qty.
    this.syncMinusButtons(lineEl);
  },

  updateSummary(cart) {
    const subtotal = document.getElementById('cart-summary-subtotal');
    const total = document.getElementById('cart-summary-total');
    const mobileTotal = document.getElementById('cart-mobile-total');

    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (total) total.textContent = formatMoney(cart.total_price);
    if (mobileTotal) mobileTotal.textContent = formatMoney(cart.total_price);
  },

  updateProgressBar(cart) {
    const fill = document.querySelector('.cart-shipping-fill');
    const msg = document.querySelector('.cart-shipping-msg');
    if (!fill || !msg) return;

    const threshold = this.thresholdCents;
    const total = cart.total_price;
    const remaining = threshold - total;
    const pct = Math.min(100, (total / threshold) * 100);

    fill.style.width = pct + '%';

    if (remaining <= 0) {
      fill.classList.add('is-full');
      msg.classList.add('is-unlocked');
      msg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg><span>YOU\'VE UNLOCKED <strong>FREE SHIPPING!</strong></span>';
    } else {
      fill.classList.remove('is-full');
      msg.classList.remove('is-unlocked');
      msg.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect width="16" height="13" x="6" y="4" rx="2"/><path d="m2 7 4-3 4 3"/><path d="M6 10h12"/></svg><span>YOU\'RE <strong>' + formatMoney(remaining) + '</strong> AWAY FROM FREE SHIPPING</span>';
    }
  },

  /* ---- Stack & Save bar live-update ----
     The bar's structure is server-rendered with item_count baked into Liquid:
     progress fill width, four tier dots (filled/unfilled), status copy, and
     the right-side "SAVING X%" badge. Mirrors the Liquid logic so the bar
     reflects post-update cart state without a page reload — same role
     updateProgressBar plays for the shipping bar.

     Also updates the order summary's discount row, which is always in the
     DOM (hidden when discount is 0) so we can flip it on/off here as the
     tier crosses 2-, 3-, and 4-item thresholds. */
  updateStackBar(cart) {
    const bar = document.querySelector('.cart-stack-bar');
    if (!bar) return; // tier pricing disabled, or cart empty — nothing to update

    const cnt = cart.item_count;
    const tier2 = parseInt(bar.dataset.tier2 || '10', 10);
    const tier3 = parseInt(bar.dataset.tier3 || '20', 10);
    const tier4 = parseInt(bar.dataset.tier4 || '30', 10);

    let currentDiscount = 0;
    if (cnt >= 4) currentDiscount = tier4;
    else if (cnt >= 3) currentDiscount = tier3;
    else if (cnt >= 2) currentDiscount = tier2;

    // Progress fill: 25% per item up to 100% at 4+
    let fillPct = 0;
    if (cnt >= 4) fillPct = 100;
    else if (cnt === 3) fillPct = 75;
    else if (cnt === 2) fillPct = 50;
    else if (cnt === 1) fillPct = 25;
    const fill = bar.querySelector('.cart-stack-fill');
    if (fill) fill.style.width = fillPct + '%';

    // Tier dots — each dot's data-tier is the item count it represents
    bar.querySelectorAll('.cart-stack-dot').forEach(dot => {
      const tier = parseInt(dot.dataset.tier, 10);
      dot.style.background = cnt >= tier ? 'var(--blood)' : 'var(--ink)';
    });

    // Status copy under the bar
    const status = bar.querySelector('.cart-stack-status');
    if (status) {
      let text = '';
      if (cnt >= 4) text = 'MAX DISCOUNT UNLOCKED \u2014 ' + tier4 + '% OFF';
      else if (cnt === 3) text = 'ADD 1 MORE FOR ' + tier4 + '% OFF';
      else if (cnt === 2) text = 'ADD 1 MORE FOR ' + tier3 + '% OFF';
      else if (cnt === 1) text = 'ADD 1 MORE FOR ' + tier2 + '% OFF';
      status.textContent = text;
    }

    // Right-side SAVING X% badge — hide when no discount earned yet
    const savingWrap = bar.querySelector('.cart-stack-saving');
    const savingValue = bar.querySelector('.cart-stack-saving-value');
    if (savingWrap) savingWrap.style.display = currentDiscount > 0 ? '' : 'none';
    if (savingValue) savingValue.textContent = currentDiscount + '%';

    // Order summary discount row — flip visibility + update label & amount
    const row = document.getElementById('cart-summary-discount-row');
    if (row) {
      if (currentDiscount > 0) {
        row.style.display = '';
        const label = document.getElementById('cart-summary-discount-label');
        const value = document.getElementById('cart-summary-discount');
        if (label) label.textContent = 'STACK DISCOUNT (' + currentDiscount + '%)';
        const discountCents = Math.round(cart.total_price * currentDiscount / 100);
        if (value) value.textContent = '-' + formatMoney(discountCents);
      } else {
        row.style.display = 'none';
      }
    }
  },

  updateCounts(cart) {
    const pageCount = document.getElementById('cart-page-count');
    const mobileCount = document.getElementById('cart-mobile-count');
    const headerCount = document.getElementById('header-cart-count');
    const drawerCount = document.getElementById('cart-drawer-count');

    const s = cart.item_count === 1 ? '' : 'S';
    if (pageCount) pageCount.textContent = cart.item_count + ' ITEM' + s;
    if (mobileCount) mobileCount.textContent = cart.item_count + ' item' + s.toLowerCase();
    if (headerCount) headerCount.textContent = cart.item_count;
    if (drawerCount) drawerCount.textContent = cart.item_count;
  },

  /* ---- Upsell Rail scroll ---- */
  initUpsellRail() {
    const rail = document.getElementById('cart-upsell-rail');
    const prev = document.getElementById('upsell-prev');
    const next = document.getElementById('upsell-next');
    if (!rail) return;

    const scrollAmount = 260;
    if (prev) prev.addEventListener('click', () => rail.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => rail.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  },

  /* ---- Load Recommendations via AJAX ---- */
  async loadRecommendations() {
    const container = document.getElementById('cart-recs');
    if (!container) return;

    const productId = container.dataset.productId;
    const cartIds = (container.dataset.cartProductIds || '').split(',');
    if (!productId) return;

    try {
      const res = await fetch(`/recommendations/products.json?product_id=${productId}&limit=8`);
      if (!res.ok) return;
      const data = await res.json();
      let products = data.products || [];

      // Filter out products already in cart
      products = products.filter(p => !cartIds.includes(String(p.id)));
      if (products.length === 0) return;

    let html = '';
    html += '<div class="cart-upsell-header" style="margin-bottom: 24px;">';
      html += '<div>';
      html += '<div class="font-mono text-[10px] tracking-[0.3em] mb-2" style="color: var(--blood);">YOU MIGHT ALSO LIKE</div>';
      html += '<h2 class="font-display text-2xl sm:text-3xl lg:text-4xl leading-[0.9] tracking-tight" style="color: var(--ink);">MORE<br>OFFENSES.</h2>';
      html += '</div>';
      html += '</div>';
      html += '<div class="cart-upsell-rail-wrap">';
      html += '<div class="cart-upsell-nav">';
      html += '<button type="button" class="cart-upsell-arrow" id="recs-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 18-6-6 6-6"/></svg></button>';
      html += '<button type="button" class="cart-upsell-arrow" id="recs-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m9 18 6-6-6-6"/></svg></button>';
      html += '</div>';
      html += '<div class="cart-upsell-rail" id="cart-recs-rail">';

      products.forEach(p => {
        const img = p.featured_image ? `<img src="${p.featured_image}" alt="${p.title}" loading="lazy">` : '';
        const price = formatMoney(p.price);
        html += `<div class="cart-upsell-card">
          <a href="${p.url}" class="cart-upsell-img">${img}</a>
          <div class="cart-upsell-info">
            <a href="${p.url}" class="cart-upsell-title">${p.title}</a>
            <div class="cart-upsell-price">${price}</div>
          </div>
          <button type="button" class="cart-upsell-add quick-add-trigger" data-product-url="${p.url}.js" aria-label="Quick add ${p.title}">+ ADD</button>
        </div>`;
      });

      html += '</div></div>';
      container.innerHTML = html;

      // Wire up carousel arrows
      const rail = document.getElementById('cart-recs-rail');
      const prevBtn = document.getElementById('recs-prev');
      const nextBtn = document.getElementById('recs-next');
      if (rail && prevBtn && nextBtn) {
        const scrollAmt = () => rail.querySelector('.cart-upsell-card')?.offsetWidth + 16 || 260;
        prevBtn.addEventListener('click', () => rail.scrollBy({ left: -scrollAmt(), behavior: 'smooth' }));
        nextBtn.addEventListener('click', () => rail.scrollBy({ left: scrollAmt(), behavior: 'smooth' }));
      }
    } catch (err) {
      console.error('Recommendations error:', err);
    }
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => CartPage.init());
} else {
  CartPage.init();
}

/* ====== STICKY PROGRESS TRACKER ====== */
const StickyProgress = (() => {
  const BAR_CHECKPOINTS = [
    { qty: 2, label: '10%' },
    { qty: 3, label: '20%' },
    { qty: 4, label: '30%' },
    { qty: 5, label: 'FREE SHIP' },
  ];

  let prevSavings = 0;
  let prevReachedTotal = 0;

  function getNextCheckpoint(cnt) {
    return BAR_CHECKPOINTS.find(cp => cp.qty > cnt);
  }

  function getStatusCopy(cnt) {
    const next = getNextCheckpoint(cnt);
    if (!next) return 'MAX SAVINGS \u00B7 30% + FREE SHIP';
    if (cnt === 0) return 'ADD 2 ITEMS \u00B7 SAVE 10%';
    if (next.label === 'FREE SHIP') {
      const dollarsAway = (100 - cnt * 24.99).toFixed(2);
      return '$' + dollarsAway + ' AWAY \u00B7 FREE SHIP';
    }
    const need = next.qty - cnt;
    return need === 1
      ? 'ADD 1 ITEM \u2192 SAVE ' + next.label
      : 'ADD ' + need + ' ITEMS \u2192 SAVE ' + next.label;
  }

  function getDiscountRate(cnt) {
    if (cnt >= 4) return 0.30;
    if (cnt >= 3) return 0.20;
    if (cnt >= 2) return 0.10;
    return 0;
  }

  function showToast(text) {
    const toast = document.getElementById('sp-toast');
    if (!toast) return;
    toast.textContent = text;
    toast.classList.add('show');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('show'), 1800);
  }

  function animateCountUp(el, from, to, duration) {
    const start = performance.now();
    function tick(now) {
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const val = from + (to - from) * eased;
      el.textContent = '$' + val.toFixed(2);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = '$' + to.toFixed(2);
    }
    requestAnimationFrame(tick);
  }

  function update(itemCount) {
    const cnt = itemCount;

    // Cart count
    const countEl = document.getElementById('sp-cart-count');
    if (countEl) countEl.textContent = cnt;

    // Flame icon
    const flame = document.getElementById('sp-flame');
    if (flame) {
      if (cnt > 0) {
        flame.style.color = 'var(--blood)';
        flame.style.opacity = '1';
      } else {
        flame.style.color = 'var(--bone)';
        flame.style.opacity = '0.4';
      }
    }

    // Bar fill: 5 items = 100%
    const fillPct = Math.min((cnt / 5) * 100, 100);
    const bar = document.getElementById('sp-progress-bar');
    if (bar) bar.style.width = fillPct + '%';

    // Tier dots
    const next = getNextCheckpoint(cnt);
    document.querySelectorAll('.sp-tier-dot').forEach(dot => {
      const qty = parseInt(dot.dataset.qty, 10);
      dot.classList.remove('pulsing');
      if (cnt >= qty) {
        dot.style.background = 'var(--blood)';
        dot.style.borderColor = 'var(--blood)';
        dot.style.width = '12px';
        dot.style.height = '12px';
        dot.style.opacity = '1';
        dot.style.boxShadow = '0 0 0 2px var(--ink), 0 0 10px rgba(230,57,70,0.7)';
      } else {
        dot.style.background = 'var(--ink)';
        dot.style.borderColor = 'var(--blood)';
        dot.style.width = '8px';
        dot.style.height = '8px';
        dot.style.opacity = '0.7';
        dot.style.boxShadow = 'none';
        if (next && next.qty === qty) {
          dot.classList.add('pulsing');
        }
      }
    });

    // Tier labels
    document.querySelectorAll('.sp-tier-label').forEach(lbl => {
      const qty = parseInt(lbl.dataset.qty, 10);
      if (cnt >= qty) {
        lbl.style.color = 'var(--blood)';
        lbl.style.opacity = '1';
      } else {
        lbl.style.color = 'var(--bone)';
        lbl.style.opacity = '0.4';
      }
    });

    // Status copy
    const lblEl = document.getElementById('sp-progress-label');
    if (lblEl) {
      lblEl.textContent = getStatusCopy(cnt);
      if (cnt >= 5) {
        lblEl.style.color = 'var(--blood)';
        lblEl.style.opacity = '1';
      } else {
        lblEl.style.color = '';
        lblEl.style.opacity = '0.9';
      }
    }

    // Savings
    const savings = cnt * 24.99 * getDiscountRate(cnt);
    const savingsEl = document.getElementById('sp-savings-amount');
    if (savingsEl) {
      if (savings > 0) {
        savingsEl.style.color = 'var(--blood)';
        savingsEl.style.opacity = '1';
        animateCountUp(savingsEl, prevSavings, savings, 600);
      } else {
        savingsEl.textContent = '$0.00';
        savingsEl.style.color = 'var(--bone)';
        savingsEl.style.opacity = '0.3';
      }
    }
    prevSavings = savings;

    // Tier-crossed celebration
    const reachedNow = BAR_CHECKPOINTS.filter(cp => cp.qty <= cnt).length;
    if (reachedNow > prevReachedTotal && reachedNow > 0) {
      const justCrossed = BAR_CHECKPOINTS[reachedNow - 1];
      const barWrap = document.getElementById('sp-bar-wrap');
      if (barWrap) {
        barWrap.classList.remove('flashing');
        void barWrap.offsetWidth;
        barWrap.classList.add('flashing');
      }
      document.querySelectorAll('.sp-tier-label').forEach(lbl => {
        if (parseInt(lbl.dataset.qty, 10) === justCrossed.qty) {
          lbl.classList.remove('bumping');
          void lbl.offsetWidth;
          lbl.classList.add('bumping');
        }
      });
      if (savingsEl && savings > 0) {
        savingsEl.classList.remove('flashing');
        void savingsEl.offsetWidth;
        savingsEl.classList.add('flashing');
      }
      if (justCrossed.label === 'FREE SHIP') {
        showToast('FREE US SHIPPING UNLOCKED');
      } else {
        showToast(justCrossed.label + ' OFF UNLOCKED');
      }
    }
    prevReachedTotal = reachedNow;
  }

  return { update };
})();

// Hook into IllegalCart.render to update sticky progress
(() => {
  const origRender = IllegalCart.render.bind(IllegalCart);
  IllegalCart.render = function(cart) {
    origRender(cart);
    StickyProgress.update(cart.item_count);
  };
})();


// Initialize on page load with current cart count
(function initStickyProgress() {
  function run() {
    const countEl = document.getElementById('sp-cart-count');
    if (countEl) {
      StickyProgress.update(parseInt(countEl.textContent, 10) || 0);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();